
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/sneeuwhoogtes-sneeuwbericht",
      function () {
        return require("private-next-pages/[region]/[resort]/sneeuwhoogtes-sneeuwbericht.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/sneeuwhoogtes-sneeuwbericht"])
      });
    }
  